// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import third-party libraries
import moment from 'moment';
import { DateTime } from 'luxon';
class AdminSceneListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(itemId) {
    const { history } = this.props;
    history.push(`/admin/authoring/scenes/${itemId}/update`);
  }

  render() {
    const { scene } = this.props;
    // const modified = moment(scene.updated).calendar();
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, scene._id)}>
        <td className="_10 u-centerText">
          { scene.posterUrl && scene.posterUrl.length > 0 ?
              <img src={scene.posterUrl} width="90" />
            :
              null
          }
        </td>
        <td className="_70">{scene.title}</td>
        
        <td className="_10">{DateTime.fromISO(scene.updated).toLocaleString(DateTime.DATE_SHORT)}</td>
      </tr>
    )
  }
}

AdminSceneListItem.propTypes = {
  scene: PropTypes.object.isRequired
}

export default withRouter(
  connect(
  )(AdminSceneListItem)
);



// WEBPACK FOOTER //
// modules/scene/components/AdminSceneListItem.js.jsx